import { Grid, Stack, Typography } from "@mui/material";
import ForgotPasswordForm from "./components/ForgotPasswordForm";

export default function ForgotPasswordPage() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="baseline"
          textAlign="center"
          sx={{ mb: { xs: -0.5, sm: 0.5 } }}
        >
          <Typography variant="h3">Find your account</Typography>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <ForgotPasswordForm />
      </Grid>
    </Grid>
  );
}
